export class ProductoVersionsTable {
  public static productoVersions: any = [{
    id: 5,
    fecha_liberacion: "17/12/2020",
    version: {id: 1, numero:"2020.1.1.0", observacion: "Versión Desactualizada"}, producto: {id: 1, nombre: "Sinergial Full"}
  }, {
    id: 6,
    fecha_liberacion: "01/3/2020",
    version: {id: 1, numero:"2021.1.1.0", observacion: "Ultima Versión"}, producto: {id: 2, nombre: "Sinergial Lite"}
  }, {
    id: 7,
    fecha_liberacion: "15/3/2020",
    version: {id: 2, numero:"2021.1.1.0", observacion: "Ultima Versión"}, producto: {id: 1, nombre: "Sinergial Full"}
  }]
}